<template>
  <div class="mc-dashboard__widget-item">
    <div class="mc-dashboard__widget-header d-flex justify-content-between">
      <div>
        <h4 class="font-size-16 teal-400 mb-1">Perbandingan Bahan Bakar (Bulan)</h4>
        <p class="font-size-10 teal-400 mb-0">
          {{ monthsPeriod }}
        </p>
      </div>
    </div>
    <div class="mc-dashboard__widget-content">
      <div>
        <b-skeleton-wrapper :loading="localLoading">
          <template #loading>
            <b-row>
              <b-col md="12">
                <b-skeleton width="100%" height="350px" />
              </b-col>
            </b-row>
          </template>
          <div v-if="!refresh" class="mc-chart">
            <BarChart
              :labels="totalChartData.fuel.labels"
              :datasets="totalChartData.fuel.datasets"
              :yLabel="$t('dashboard.text.litre')"
            />
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/Chart/Bar'

export default {
  components: {
    BarChart,
  },
  props: {
    loading: {
      type: Boolean,
    },
    tripsStatistics: {
      type: Object,
    },
  },

  data() {
    return {
      isLayoutEdit: false,
      refresh: false,
      months: [],
      localLoading: this.loading,
      actualData: [],
      standardData: [],
      monthsPeriod: '',
    }
  },

  computed: {
    tripsStatisticsIsReady() {
      return (
        this.tripsStatistics && this.tripsStatistics.data && this.tripsStatistics.data.length > 0
      )
    },

    totalChartData() {
      return {
        fuel: {
          labels: this.months,
          datasets: [
            {
              type: 'line',
              data: this.standardData,
              label: 'Standar',
              borderColor: '#ff8a00',
              fill: false,
              pointRadius: 2,
              lineTension: 0,
              borderWidth: 4,
            },
            {
              type: 'bar',
              data: this.actualData,
              label: 'Aktual',
              backgroundColor: '#0d4491',
              barPercentage: 0.5,
            },
          ],
        },
      }
    },
  },

  watch: {
    tripsStatistics: {
      handler(newVal) {
        if (this.tripsStatisticsIsReady) {
          this.prepareChartData()
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    if (this.tripsStatisticsIsReady) {
      this.prepareChartData()
    }
  },

  methods: {
    prepareChartData() {
      this.localLoading = true
      this.refresh = true

      this.months = this.tripsStatistics?.data.map((item) => item.month)

      this.actualData = this.tripsStatistics?.data.map((item) =>
        Number(parseFloat(item.fuelConsumption.chosenValue).toFixed(2))
      )

      this.standardData = this.tripsStatistics?.data.map((item) =>
        Number(parseFloat(item.fuelConsumption.compareValue).toFixed(2))
      )

      const months = this.tripsStatistics?.data.map((item) => `${item.month} ${item.year}`)
      this.monthsPeriod = `${months[0]} - ${months[2]}`

      setTimeout(() => {
        this.refresh = false
        this.localLoading = false
      }, 500)
    },
  },
}
</script>
